import { Injectable } from "@angular/core";
import { ResponseData } from "../../helpers/response";
import { Observable } from "rxjs/internal/Observable";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class UploadButtonService {
  constructor(public http: HttpClient) {}

  send(url: string, form: FormData): Observable<ResponseData> {
    return this.http.post<ResponseData>(url, form);
  }
}
